// 
// -----------------------------------------------------------------------------
(function ($elements) {
	$elements.each(function () {
		
	});
})($( '.elements' ));